/**
 * @generated SignedSource<<3fb6419946c14604f75476530835a5bc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type OrderStatusType = "ClosedByAdmin" | "HasBillingDetails" | "HasCart" | "HasPaymentDetails" | "PaymentInProcess" | "PaymentReceived" | "Purchased" | "PurchasedAwaitingAccount" | "Transient";
import { FragmentRefs } from "relay-runtime";
export type closeOrderAction_OrderFragment$data = {
  readonly id: string;
  readonly status: OrderStatusType;
  readonly " $fragmentType": "closeOrderAction_OrderFragment";
};
export type closeOrderAction_OrderFragment$key = {
  readonly " $data"?: closeOrderAction_OrderFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"closeOrderAction_OrderFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "closeOrderAction_OrderFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "Order",
  "abstractKey": null
};

(node as any).hash = "d37483d922c4781ef479103dc706f0ae";

export default node;
